// extracted by mini-css-extract-plugin
module.exports = {"boxImage":"_1GFLN4vFX5u1sCVq4yuJ-W","active":"_3iyOiXRaEbPmRSiGol8G5n","deleteImage":"_2W-QLnkcLqx2X97jSzoDL0","hover":"_3J2QhUM07bPxl_AfK1GR0b"};